import { NoPhotography } from '@mui/icons-material'
import { ButtonBase, Card, Grid, Theme, Typography } from '@mui/material'

interface DamagePhotoCardProps {
  complete?: boolean
  damagePhoto?: File
  disabled?: boolean
  onClick?: () => void
  photo: 1 | 2 | 3
  warning?: boolean
}

export default function DamagePhotoCard({ complete, damagePhoto, disabled, onClick, photo, warning }: DamagePhotoCardProps) {
  const getColor = (theme: Theme): string => {
    if (disabled) {
      return theme.palette.grey[400] // '#b0a8b9'
    } else if (complete) {
      return theme.palette.success.main // '#009c45'
    } else if (warning) {
      return theme.palette.warning.main // '#ffc75f'
    }

    return theme.palette.error.main // '#ff0000'
  }

  return (
    <Card
      component={ButtonBase}
      onClick={onClick}
      sx={theme => ({
        backgroundColor: getColor(theme),
        color: '#fff',
        p: 1,
        width: '220px'
      })}
    >
      <Grid container spacing={0} alignItems='center' justifyContent='center'>
        <Grid item sx={{ minHeight: 112.5, maxHeight: 112.5 }}>
          {damagePhoto && (
            <img
              alt={`Damage Photo ${photo}`}
              src={damagePhoto ? URL.createObjectURL(damagePhoto) : ''}
              width={200}
              height={112.5}
            />
          )}
          {!damagePhoto && <NoPhotography fontSize='large' sx={{ height: 112.5 }} />}
        </Grid>

        <Grid item xs={12}>
          <Typography align='center'>Damage Photo {photo}</Typography>
        </Grid>
      </Grid>
    </Card>
  )
}
